export default __webpack_public_path__ + "static/cheer-bananas-vertical-3cfa932008bcdf2407bdc0daaf6da819.png";